"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var create_exports = {};
__export(create_exports, {
  attachmentField: () => attachmentField,
  autocomplete: () => autocomplete,
  bodyText: () => bodyText,
  card: () => card,
  checkbox: () => checkbox,
  columns2: () => columns2,
  columns3: () => columns3,
  createSectionConstructor: () => createSectionConstructor,
  dynamicAttr: () => dynamicAttr,
  dynamicGrid: () => dynamicGrid,
  dynamicImage: () => dynamicImage,
  dynamicValue: () => dynamicValue,
  enumSelectOptions: () => enumSelectOptions,
  featureField: () => featureField,
  featureFieldCartographerMapStyle: () => featureFieldCartographerMapStyle,
  featureFieldExternalMapStyle: () => featureFieldExternalMapStyle,
  form: () => form,
  fullWidth: () => fullWidth,
  grid: () => grid,
  heading: () => heading,
  helpText: () => helpText,
  integerField: () => integerField,
  localAutocompleteSource: () => localAutocompleteSource,
  multiSelect: () => multiSelect,
  nearestFeatureField: () => nearestFeatureField,
  numberField: () => numberField,
  page: () => page,
  pointField: () => pointField,
  primarySurveyorField: () => primarySurveyorField,
  primaryTeamField: () => primaryTeamField,
  repeat: () => repeat,
  requireRole: () => requireRole,
  scope: () => scope,
  section: () => section,
  sectionHeading: () => sectionHeading,
  select: () => select,
  selectOption: () => selectOption,
  subsection: () => subsection,
  subsectionHeading: () => subsectionHeading,
  subsubsection: () => subsubsection,
  subsubsectionHeading: () => subsubsectionHeading,
  teamField: () => teamField,
  text: () => text,
  textArea: () => textArea,
  textField: () => textField,
  timestampField: () => timestampField,
  userRefField: () => userRefField,
  visibility: () => visibility,
  vstack: () => vstack
});
module.exports = __toCommonJS(create_exports);
function textField(props) {
  return { type: "TextField", ...props };
}
function textArea(props) {
  return { type: "TextArea", ...props };
}
function autocomplete(props) {
  return { type: "Autocomplete", ...props };
}
function localAutocompleteSource(options) {
  return { type: "Local", options };
}
function integerField(props) {
  return { type: "IntegerField", ...props };
}
function numberField(props) {
  return { type: "NumberField", ...props };
}
function userRefField(props) {
  return { type: "UserRefField", ...props };
}
function teamField(props) {
  return { type: "TeamField", ...props };
}
function timestampField(props) {
  return { type: "TimestampField", ...props };
}
function attachmentField(props) {
  return { type: "AttachmentField", ...props };
}
function pointField(props) {
  return { type: "PointField", ...props };
}
function featureFieldCartographerMapStyle(props) {
  return { type: "Cartographer", ...props };
}
function featureFieldExternalMapStyle(props) {
  return { type: "External", ...props };
}
function featureField(props) {
  return { type: "FeatureField", ...props };
}
function nearestFeatureField(props) {
  return { type: "NearestFeatureField", ...props };
}
function checkbox(props) {
  return { type: "Checkbox", ...props };
}
function primarySurveyorField(props) {
  const { label, help = "Who was the surveyor?", rule } = props;
  return { type: "PrimarySurveyorField", label, help, rule };
}
function primaryTeamField(props) {
  const { label, help = "Which team was the person surveying for?", rule } = props;
  return { type: "PrimaryTeamField", label, help, rule };
}
function selectOption(value, label, key) {
  return { value, label, key };
}
function enumSelectOptions(source, showValues = false) {
  const entries = Array.isArray(source) ? source : source.entries;
  const options = entries.map(({ value, label }) => ({
    value,
    label: showValues ? `${value} - ${label}` : label
  }));
  return options;
}
function select(props) {
  return { type: "Select", ...props };
}
function multiSelect(props) {
  return { type: "MultiSelect", ...props };
}
function card(props) {
  return { type: "Card", ...props };
}
function dynamicAttr(props) {
  return { ...props };
}
function dynamicValue(props) {
  return { type: "DynamicValue", ...props };
}
function dynamicGrid(props) {
  return { type: "DynamicGrid", ...props };
}
function dynamicImage(props) {
  return { type: "DynamicImage", ...props };
}
function fullWidth(block) {
  return { type: "FullWidth", block };
}
function heading(props) {
  return { type: "Heading", ...props };
}
function sectionHeading(text2) {
  return { type: "Heading", level: "section", text: text2 };
}
function subsectionHeading(text2) {
  return { type: "Heading", level: "subsection", text: text2 };
}
function subsubsectionHeading(text2) {
  return { type: "Heading", level: "subsubsection", text: text2 };
}
function text(props) {
  return { type: "Text", ...props };
}
function bodyText(markdown) {
  return { type: "Text", appearance: "default", markdown };
}
function helpText(markdown) {
  return { type: "Text", appearance: "help", markdown };
}
function grid(props) {
  const { blocks, ...rest } = props;
  return {
    type: "Group",
    ...rest,
    blocks: Array.isArray(blocks) ? blocks : [blocks]
  };
}
function columns2(...blocks) {
  return { type: "Group", columns: 2, blocks };
}
function columns3(...blocks) {
  return { type: "Group", columns: 3, blocks };
}
function vstack(...blocks) {
  return { type: "Group", columns: 1, blocks };
}
function repeat(props) {
  return { type: "Repeat", ...props };
}
function requireRole(props) {
  return { type: "RequireRole", ...props };
}
function scope(props) {
  return { type: "Scope", ...props };
}
function visibility(props) {
  return { type: "Visibility", ...props };
}
function createSectionConstructor(myHeading) {
  return function(props) {
    const { title, path, blocks: _blocks, visible, appearance, help } = props;
    const blocks = [
      ...title == null ? [] : [myHeading(title)],
      ...help == null ? [] : [helpText(help)],
      ...Array.isArray(_blocks) ? [..._blocks] : [_blocks]
    ];
    let content = vstack(...blocks);
    if (appearance != null) {
      content = card({ appearance, block: content });
    }
    if (path != null && path.length > 0) {
      content = scope({ path, block: content });
    }
    if (visible != null) {
      content = visibility({ visible, block: content });
    }
    return content;
  };
}
const section = createSectionConstructor(sectionHeading);
const subsection = createSectionConstructor(subsectionHeading);
const subsubsection = createSectionConstructor(subsubsectionHeading);
function page(props) {
  const { blocks, ...rest } = props;
  return {
    type: "Page",
    ...rest,
    blocks: Array.isArray(blocks) ? blocks : [blocks]
  };
}
function form(props) {
  const { pages, ...rest } = props;
  return {
    type: "Form",
    ...rest,
    pages: Array.isArray(pages) ? pages : [pages]
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  attachmentField,
  autocomplete,
  bodyText,
  card,
  checkbox,
  columns2,
  columns3,
  createSectionConstructor,
  dynamicAttr,
  dynamicGrid,
  dynamicImage,
  dynamicValue,
  enumSelectOptions,
  featureField,
  featureFieldCartographerMapStyle,
  featureFieldExternalMapStyle,
  form,
  fullWidth,
  grid,
  heading,
  helpText,
  integerField,
  localAutocompleteSource,
  multiSelect,
  nearestFeatureField,
  numberField,
  page,
  pointField,
  primarySurveyorField,
  primaryTeamField,
  repeat,
  requireRole,
  scope,
  section,
  sectionHeading,
  select,
  selectOption,
  subsection,
  subsectionHeading,
  subsubsection,
  subsubsectionHeading,
  teamField,
  text,
  textArea,
  textField,
  timestampField,
  userRefField,
  visibility,
  vstack
});
//# sourceMappingURL=create.js.map
